var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59164 4.29263C5.98217 4.68316 5.98217 5.31636 5.59164 5.70689L1.82037 9.4781C1.42986 9.86863 0.796698 9.86863 0.406171 9.47811C0.0156512 9.08758 0.0156512 8.45441 0.406171 8.06389L3.4703 4.99976L0.406171 1.93563C0.0156509 1.54509 0.0156509 0.91196 0.406171 0.521426C0.796697 0.130893 1.42986 0.130893 1.82037 0.521426L5.59164 4.29263Z",
    fill: "#21272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.12d12f25494312ac319dacec09308737.svg";
export { ForwardRef as ReactComponent };